import { Component, OnInit } from '@angular/core';
import { PaymentsStoreService } from './services/payments-store.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  public selectChartState$ = this.store.selectChartState$;

  constructor(private store: PaymentsStoreService) { }

  ngOnInit() {
  }

}
